import React, { useState, useRef, useEffect } from "react"
import Button from "@material-ui/core/Button"
import Modal from "@material-ui/core/Modal"
import Backdrop from "@material-ui/core/Backdrop"
import ChatIcon from "@material-ui/icons/Chat"
import { makeStyles } from "@material-ui/core/styles"
import { useTranslation } from "react-i18next"
import { useLocation } from "react-router-dom"
import { CloseQAndASvg, QAndASvg } from "../components/icons"
import { Box, Fade, Paper, Popper, Typography, useTheme } from "@material-ui/core"
import { useDispatch, useSelector } from "react-redux"
import AnzyzAsk from "../components/anzyzAsk/AnzyzAsk"
import { getChat } from "../actions/viewerActions"
import { getInfo } from "../actions/infoActions"

const useStyles = makeStyles((theme) => ({
	button: {
		position: "fixed",
		bottom: theme.spacing(2),
		right: theme.spacing(2),
		zIndex: 9999,
		cursor: "pointer",
	},
	modal: {
		display: "flex",
		alignItems: "center",
		justifyContent: "center",
	},
	paper: {
		backgroundColor: theme.palette.background.paper,
		padding: theme.spacing(2, 4, 3),
		maxHeight: "80%",
		overflowY: "auto",
	},
	scrollButton: {
		position: "absolute",
		bottom: theme.spacing(2),
		right: theme.spacing(2),
	},
}))
const PageQAndA = () => {
	const classes = useStyles()
	const [t] = useTranslation("global")
	const theme = useTheme()
	const [open, setOpen] = useState(false)
	const chatRef = useRef(null)
	const [anchorEl, setAnchorEl] = useState(null)
	const [placement, setPlacement] = useState()
	const dispatch = useDispatch()
	const location = useLocation()
	const aiEnabled = useSelector((state) => state?.info?.version?.ai_enabled)
	const handleOpen = () => {
		setOpen(true)
	}
	useEffect(() => {
		dispatch(getInfo())
	}, [])
	const handleClose = () => {
		setOpen(false)
	}
	const handleScrollToBottom = () => {
		if (chatRef.current) {
			chatRef.current.scrollTop = chatRef.current.scrollHeight
		}
	}

	const handleClick = (newPlacement) => (event) => {
		setAnchorEl(event.currentTarget)
		setOpen((prev) => placement !== newPlacement || !prev)
		setPlacement(newPlacement)
	}

	return (
		<div>
			{aiEnabled && (
				<Box className={classes.button} onClick={handleClick("left-end")}>
					{open ? <CloseQAndASvg /> : <QAndASvg />}
				</Box>
			)}

			<Popper
				sx={{ zIndex: 1200 }}
				open={open}
				anchorEl={anchorEl}
				placement={placement}
				transition
				disablePortal={true}
				modifiers={{
					flip: {
						enabled: false,
					},
					preventOverflow: {
						enabled: true,
						boundariesElement: "window",
					},
				}}
				style={{
					zIndex: 2,
					width: "444px",
					height: "600px",
					boxShadow: `0px 4px 4px 0px ${theme.palette.grey.D400}`,
					borderTop: `solid 1px ${theme.palette.grey.D400}`,
					backgroundColor: theme.palette.common.white,
				}}
			>
				{({ TransitionProps }) => (
					<Fade {...TransitionProps} timeout={350}>
						<AnzyzAsk />
					</Fade>
				)}
			</Popper>
		</div>
	)
}
export default PageQAndA
